import {
  ConfigProvider,
  Flex,
  Typography,
} from 'antd'
import React from 'react'

import { ChatterSalesDetail } from '@/model/analytics'
import { formatPercentage } from '@/utils/formatter'

import s from './chatter-sales-report-tooltip.module.css'

const { Text } = Typography

export default function ChatterSalesReportTooltip({
  data,
}: { data: ChatterSalesDetail }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: 'var(--ant-color-text)',
        },
      }}
    >
      <Flex vertical className={s.Tooltip}>
        <Text>{data.dateStr}</Text>
        <Text>Earnings: ${data.earnings} Growth: {formatPercentage({ digit: 0 })(data.growth)}</Text>
        {
          data.channels
            .filter(({ earnings }) => (earnings !== 0))
            .map(({ name, earnings }) => (
              <Text key={name} className={s.Channel}>{name}: ${earnings}</Text>
            ))
        }
      </Flex>
    </ConfigProvider>
  )
}
